import React from "react";
import "./PrimaryButton.css";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  style?: React.CSSProperties;
}

const PrimaryButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  className = "",
  type = "button",
  icon,
  iconPosition = "left",
  style,
}) => {
  return (
    <button
      type={type}
      className={`custom-button ${fullWidth ? "full-width" : ""} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {icon && iconPosition === "left" && (
        <span className="button-icon button-icon-left">{icon}</span>
      )}
      <span className="button-text">{children}</span>
      {icon && iconPosition === "right" && (
        <span className="button-icon button-icon-right">{icon}</span>
      )}
    </button>
  );
};

export default PrimaryButton;
